import { getApolloClient } from "./apollo/apollo";
import AppLayout from "../app-frame";
import { ApolloProvider } from "@apollo/client";

export default function RouterlessApp() {
  return (
    <ApolloProvider client={getApolloClient()}>
      <AppLayout />
    </ApolloProvider>
  );
}
